import { RestService, Rest } from '@abp/ng.core';
import type { PagedResultDto } from '@abp/ng.core';
import { Injectable } from '@angular/core';
import type { ColppyHealthCheckDto, ColppyLogDto, GetColppyLogsDto } from '../../colppy/dto/models';

@Injectable({
  providedIn: 'root',
})
export class ColppyHealthCheckService {
  apiName = 'Default';
  

  getHealthCheck = (config?: Partial<Rest.Config>) =>
    this.restService.request<any, ColppyHealthCheckDto>({
      method: 'GET',
      url: '/api/app/colppy-health-check/health-check',
    },
    { apiName: this.apiName,...config });
  

  getLogs = (input: GetColppyLogsDto, config?: Partial<Rest.Config>) =>
    this.restService.request<any, PagedResultDto<ColppyLogDto>>({
      method: 'GET',
      url: '/api/app/colppy-health-check/logs',
      params: { entityType: input.entityType, entityId: input.entityId, operation: input.operation, logType: input.logType, severity: input.severity, isResolved: input.isResolved, fromDate: input.fromDate, toDate: input.toDate, keyword: input.keyword, sorting: input.sorting, skipCount: input.skipCount, maxResultCount: input.maxResultCount },
    },
    { apiName: this.apiName,...config });

  constructor(private restService: RestService) {}
}
